import { NgModule } from '@angular/core';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import {SharedModule} from "../shared/shared.module";

@NgModule({
  imports: [
    SharedModule,
  ],
  exports: [ NavbarComponent, SidebarComponent ],
  declarations: [ NavbarComponent, SidebarComponent ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts